import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { LinkedinShareButton, EmailShareButton, LinkedinIcon, EmailIcon} from 'react-share';
import SideNavPublishButton from '../body/visibility/SideNavPublishButton';
import {PublishWarningError} from '../../elements/ui';
import Ionicon from "react-ionicons";

class ShareModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            isWarningModalOpen: false
        }
    }

    render () {


        const { isOpen, onClose, url, visibility, summary, experience } = this.props;

        if (isOpen === false )
            return null;

        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                        <button className="close-popup" type="button" onClick={ () => onClose() }><Ionicon icon="ion-close"/></button>



                        { // small validation if visibility (this.props) === 1 or 0 (from database)
                            visibility.visible &&
                            visibility.visible !== null &&
                            visibility.visible !== 'undefined'
                            ?
                            //  If visibility === true || 1 - render ShareModal
                            <div>
                            <h2 classname="h2">Share your profile</h2>
                            <p className="p-tag">To view and share your In Touch Networks profile you can use:</p>
                            <ul className="buttons-left">
                                <li>
                                    <a className="btn btn-primary--ghost" type="button" href={ url } target="_blank">
                                        <span className="label">View your profile</span>
                                    </a>
                                </li>
                                <li>
                                    <CopyToClipboard text={ url }
                                                     onCopy={() => this.setState( { copied: true } ) }>
                                        <button className="btn btn-primary" type="button">
                                            <span className="label">Copy to Clipboard</span>
                                            <span className="icon icon-right"><Ionicon icon="ion-ios-copy"/></span>
                                        </button>
                                    </CopyToClipboard>
                                </li>
                                { this.state.copied && <li><span className="tooltip-inline tooltip-ok">Copied <Ionicon icon="ion-android-checkmark-circle"/></span></li> }
                            </ul>
                            <ul className="buttons-left">
                                <li>
                                    <LinkedinShareButton title="My In Touch Networks profile" description="Check it out!" url={ url }>
                                        <LinkedinIcon size={ 38 } round={ true } />
                                    </LinkedinShareButton>
                                </li>
                                <li>
                                    <EmailShareButton subject="My In Touch Networks profile" body={`Check it out my In Touch Networks profile: ${ url }`}>
                                        <EmailIcon size={ 38 } round={ true } />
                                    </EmailShareButton>
                                </li>
                            </ul>
                            </div>
                            : // If visibility === false || 0 - render static text with info
                                <div>
                                    <h2 classname="h2">Share your profile</h2>
                                    <p className="p-tag">For your profile to be visible, it must be published first:</p>
                                    <SideNavPublishButton
                                        {...visibility}
                                        summary={summary}
                                        experience={experience}
                                        openWarningModal={() => this.setState({ isWarningModalOpen: true })}
                                    />
                                </div>
                        }

                    </div>
                </div>
                {
                    //Warning modal if profile is not completed
                }
                {this.state.isWarningModalOpen && <PublishWarningError
                    cancelWarningModal={() => this.setState({ isWarningModalOpen: false })}
                />}
            </div>
        )
    }
}

ShareModal.propTypes = {
    url: PropTypes.string,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    visibility : PropTypes.object,
    summary: PropTypes.object,
    experience: PropTypes.object
}

export default ShareModal;



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/ShareModal.js